module.exports = __webpack_public_path__ + "img/FloatingHeader.9b7dd85b.png";